/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Hook } from './Hook.js';
import {
    HookFromJSON,
    HookFromJSONTyped,
    HookToJSON,
} from './Hook.js';

/**
 * 
 * @export
 * @interface ListHooksResponse
 */
export interface ListHooksResponse {
    /**
     * 
     * @type {Array<Hook>}
     * @memberof ListHooksResponse
     */
    data?: Array<Hook>;
    /**
     * 
     * @type {number}
     * @memberof ListHooksResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof ListHooksResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ListHooksResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof ListHooksResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the ListHooksResponse interface.
 */
export function instanceOfListHooksResponse(value: object): boolean {
    return true;
}

export function ListHooksResponseFromJSON(json: any): ListHooksResponse {
    return ListHooksResponseFromJSONTyped(json, false);
}

export function ListHooksResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListHooksResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(HookFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ListHooksResponseToJSON(value?: ListHooksResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(HookToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

